










import Vue from 'vue';

export default Vue.extend({
  name: 'CreativeModerationStatusPopover',
  props: {
    status: {
      type: String,
    },
  },
  computed: {
    getStatus(): string {
      switch (this.status) {
        case 'approve':
          return 'pages.campaignForm.tabs.creatives.popover.approve';
        case 'reject':
          return 'pages.campaignForm.tabs.creatives.popover.reject';
        default:
          return 'pages.campaignForm.tabs.creatives.popover.moderation';
      }
    }
  }
});
